import {
  Image,
  InputNumber,
  InputText,
  Loading,
  ModalPinCode,
} from 'components';
import { Button, InputWraper, useForm } from 'modules';
import { Icon } from 'components/icon';
import React, { useEffect, useState } from 'react';
import toast from 'react-hot-toast';
import { useNavigate } from 'react-router-dom';
import { getEnv } from 'configs/env';
import { MainRouteKeys } from 'routes/enums';
import {
  useCheckPhoneNumberTransferQuery,
  useCheckPinCodeMutation,
  useWalletTransferMutation,
  useGetBalanceQuery,
} from 'services';
import { UserSearchEntity } from 'services/openapi';
import { getUserInfo } from 'utils/helpers';

import { formSchema } from './config';

const BalanceTransferFeature = (): JSX.Element => {
  const [phoneNumber, setPhoneNumber] = useState<string>('');

  const [phoneNumberDebounce, setPhoneNumberDebounce] = useState<string>('');

  const [isShowPopup, setIsShowPopup] = useState<boolean>(false);

  const navigator = useNavigate();

  const {
    data: dataCheckPhoneNo,
    isFetching,
    refetch,
  } = useCheckPhoneNumberTransferQuery({ phoneNumber });

  const {
    mutateAsync: mutateAsyncCheckPinCode,
    isLoading: isLoadingCheckPinCode,
  } = useCheckPinCodeMutation();

  const { mutateAsync: mutateAsyncTransfer, isLoading } =
    useWalletTransferMutation();

  const { refetch: refetchBalance } = useGetBalanceQuery();

  const {
    handleSubmit: submitForm,
    getInputProps,
    getValue,
    setErrors,
    validateForm,
  } = useForm({
    structure: formSchema,
    onSubmit: () => {
      if (!dataCheckPhoneNo?.data?.length) {
        toast.error('Không tìm thấy tài khoản người nhận');
        return;
      }

      setIsShowPopup(true);
    },
  });

  const handleSubmit = async (event: React.FormEvent<HTMLFormElement>) => {
    event.preventDefault();

    const errors = await validateForm();
    if (Object.keys(errors).length) {
      setErrors(errors);
      return;
    }

    submitForm(event);
  };

  useEffect(() => {
    const timeout = setTimeout(() => {
      setPhoneNumberDebounce(phoneNumber);
    }, 500);

    return () => clearTimeout(timeout);
  }, [phoneNumber]);

  useEffect(() => {
    if (phoneNumberDebounce) {
      refetch();
    }
  }, [phoneNumberDebounce]);

  async function handleCheckPinCode(pinCode: string) {
    const { id: fundId } = getUserInfo();

    const amount = getValue('amount');

    try {
      const dataCheckPinCode = await mutateAsyncCheckPinCode({ pinCode });

      if (!dataCheckPinCode?.isValid) {
        dataCheckPinCode?.message?.map((item: string) => toast.error(item));
      }
      if (dataCheckPinCode && dataCheckPinCode?.isValid) {
        const dataTransfer = await mutateAsyncTransfer({
          toUserId: dataCheckPhoneNo?.data?.[0]?.id || '',
          amount,
          reason: '',
          pinCode,
          fundId,
        });

        if (dataTransfer && dataTransfer?.statusCode === 200) {
          refetchBalance();
          setIsShowPopup(false);
          toast.success('Chuyển điểm thành công');
          navigator(MainRouteKeys.Balance);
        }
      }
    } catch (error) {
      console.error(error);
    }
  }

  const renderDataUser = () => {
    if (!dataCheckPhoneNo) {
      return <div> </div>;
    }

    if (!dataCheckPhoneNo?.data?.length) {
      return <div>Không tìm thấy tài khoản</div>;
    }

    return dataCheckPhoneNo?.data?.map((item: UserSearchEntity) => (
      <div key={item.id} className='col-md-6 UserHead text-center'>
        <div className='profile ctas'>
          <Image
            src={
              item?.avatar
                ? `${getEnv('REACT_APP_UPLOAD_AVT')}${item?.avatar}`
                : '/assets/images/no-image.jpg'
            }
            type='avatar'
          />
          <div className='info'>
            <div className='name'>{item?.fullName}</div>
            <div className='email'>{item?.phoneNumber}</div>
          </div>
        </div>
      </div>
    ));
  };

  return (
    <>
      <div className='balance-management balance-management--transfer'>
        <div className='balance-management__title'>Chuyển điểm</div>

        <form onSubmit={handleSubmit}>
          <Loading
            isLoading={isFetching}
            className='balance-management__transfer-form'
          >
            <div className='balance-management__transfer-field'>
              <InputWraper
                label='Người nhận'
                inputProps={getInputProps('phoneNumber')}
                onChangeCallback={setPhoneNumber}
                component={InputText}
              />
            </div>

            <div className='balance-management__transfer-field'>
              <InputWraper
                label='Số điểm'
                component={InputNumber}
                inputProps={getInputProps('amount')}
              />
            </div>

            <div className='balance-management__form--btn'>
              {renderDataUser()}
              <Button
                type='submit'
                isLoading={isLoading}
                disabled={isLoading || isFetching}
                buttonType='success'
                icon={() => <Icon.Transfer size={18} />}
                label='Chuyển điểm'
              />
            </div>
          </Loading>
        </form>
      </div>

      <ModalPinCode
        isOpen={isShowPopup}
        isLoading={isLoading || isLoadingCheckPinCode}
        onClose={() => setIsShowPopup(false)}
        onConfirm={handleCheckPinCode}
      />
    </>
  );
};

export default BalanceTransferFeature;
